import React from 'react';
import { Spinner } from 'grommet';
import './UgSpinner.css';

export const UgSpinner = props => (
    <Spinner {...props} className={'ugSpinner'} />
);